import type {SearchRules} from '../../types';
import {SearchTypeCart} from '../constants';

/**
 * Check if rules contain current cart
 * @param searchRules Search rules
 * @param id Cart id
 * @returns
 */
export const rulesContainCart = (
	searchRules: Pick<SearchRules, 'elementTypes' | 'elementValue1s'>,
	id: number,
) =>
	searchRules.elementTypes.some(
		(elementType, index) =>
			elementType === SearchTypeCart &&
			searchRules.elementValue1s[index] === id,
	);

export default rulesContainCart;
